import BottomLoader from './BottomLoader'

export default BottomLoader
